import { minimalInputTheme } from '@/app/theme';

export const inputProps = {
	...minimalInputTheme,
	'& .MuiInput-underline:before': {
		borderBottom: 'none',
	},
	'& .MuiInputBase-input': {
		color: 'inherit',
		fontWeight: 'inherit',
		padding: '0 0 5px',
	},
};

export const claimHeaders = {
	dealStage: 'Claim status',
	Status: 'Subject of Loss',
	SubjectOfLoss: 'Subject of Loss details',
	ReportedDate: 'Date reported',
	LossDate: 'Date of loss',
	PolicyNumber: 'Policy number',
	PolicyPeriod: 'Policy period',
	InsurerName: 'Insurer',
	repairer: 'Repairer',
	assessor: 'Assessor',
	Excess: 'Excess',
	claimNumber: 'Claim number',
	EstimateOfLossAmount: 'Estimate of loss',
	PaidAmount: 'Total Paid',
	Description: 'Description of loss',
};

// Character limits Insight enforces on Claim/Update
export const insightMaxLengths = {
	Description: 100,
};
